import { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import { DashboardLayout } from "components/layout/components/DashboardLayout";
import { useGetUserInfo } from "hooks/useGetUserInfo";

import UploadPage from "./components/upload-page";
import CVDetailsPage from "./components/CVDetailsPage";

import "./assets/style.css";

import { HomeOutlined, RightOutlined } from "@ant-design/icons";

import { routePath } from "config/routeMgt/routePath";

export default function Page() {
  const navigate = useNavigate();
  const location = useLocation();

  const { userInfo } = useGetUserInfo();

  useEffect(() => {
    if (userInfo?.type === "talent") {
      navigate("/");
    }
  }, [userInfo, navigate]);

  const searchParams = new URLSearchParams(location.search);
  const currentView = searchParams.get("view");
  const batchId = searchParams.get("batchId");

  const isScanResults = currentView === "scan-results";
  const isCVDetails = currentView === "cv-details";

  const selectedCandidate = location.state?.selectedCandidate;
  const selectedItem = location.state?.selectedItem;

  const pageTitle = isCVDetails
    ? "CV Details"
    : isScanResults
      ? "Scan Results"
      : "New Upload";

  const handleCVSmartScreen = () => {
    navigate(routePath.cvchat);
  };

  const handleNewUpload = () => {
    navigate(`${routePath.cvchat}?view=new-upload`);
  };

  const handleScanResults = () => {
    const resolvedBatchId = batchId || selectedItem?.id;
    const scanResultsPath = resolvedBatchId
      ? `${routePath.cvchat}?view=scan-results&batchId=${encodeURIComponent(
        String(resolvedBatchId),
      )}`
      : `${routePath.cvchat}?view=scan-results`;

    navigate(scanResultsPath, {
      state: {
        selectedItem,
      },
    });
  };

  const handleBackToScanResults = () => {
    handleScanResults();
  };

  return (
    <DashboardLayout>
      <div className="px-4 pt-4">

        <h1 className="text-xl font-semibold text-gray-900">{pageTitle}</h1>

        <p className="mt-1 text-sm text-gray-500">
          {isCVDetails
            ? "View the summary of ranked cv details"
            : isScanResults
              ? "View cv scan results"
              : "Upload talent CVs and get automatic ranking"}
        </p>

        <div className="mt-8">
          <h3 className="text-sm flex items-center gap-1 text-gray-700">
            <HomeOutlined className="text-gray-500" />

            <button
              type="button"
              onClick={handleCVSmartScreen}
              className="text-sm text-blue-600 hover:underline cursor-pointer bg-transparent border-0 p-0"
            >
              CV Smart Screen
            </button>

            <RightOutlined className="text-xs text-gray-400" />

            {!isScanResults && !isCVDetails && (
              <button
                type="button"
                onClick={handleNewUpload}
                className="text-sm text-blue-600 hover:underline cursor-pointer bg-transparent border-0 p-0"
              >
                New Upload
              </button>
            )}

            {(isScanResults || isCVDetails) && (
              <>
                <button
                  type="button"
                  onClick={handleNewUpload}
                  className="text-sm text-blue-600 hover:underline cursor-pointer bg-transparent border-0 p-0"
                >
                  New Upload
                </button>

                <RightOutlined className="text-xs text-gray-400" />

                <button
                  type="button"
                  onClick={handleScanResults}
                  className="text-sm text-blue-600 hover:underline cursor-pointer bg-transparent border-0 p-0"
                >
                  Scan Results
                </button>
              </>
            )}
          </h3>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-4">
        {isCVDetails ? (
          <CVDetailsPage
            candidateData={selectedCandidate}
            onBack={handleBackToScanResults}
          />
        ) : (
          <UploadPage />
        )}
      </div>
    </DashboardLayout>
  );
}
